import { useEffect, useState, useRef, type FunctionComponent, } from "react"
import { formatAddress, } from "./helpers";
import { AccountDD, } from "./AccountDD";
import { useAccount } from "wagmi";

export declare type AccountELProps = {

};


export const AccountEL: FunctionComponent<AccountELProps> = ({

}) => {

	const { address } = useAccount()

	const over = useRef(false);
	const [, setForceRender] = useState<any>();
	const choosing = useRef(false);

	const [rect, setRect] = useState<DOMRect | null>(null);
	const compRef = useRef<HTMLDivElement>(null);
	const classes = () => [`account`].join(" ");
	const onClientResize = () => {
		if (compRef.current) {
			setRect(compRef.current.getBoundingClientRect());
			return;
		}
	};


	useEffect(() => {
		if (compRef.current) {
			setRect(compRef.current.getBoundingClientRect());
			const { visualViewport, } = window;
			if (visualViewport) {
				visualViewport.addEventListener("resize", onClientResize);
				window.addEventListener("scroll", onClientResize);
				window.addEventListener("mousedown", onMouseDownOut);``
				return () => {
					visualViewport.removeEventListener("resize", onClientResize);
					window.removeEventListener("scroll", onClientResize);
					window.removeEventListener("mousedown", onMouseDownOut);
				}
			}
			else {
				window.addEventListener("resize", onClientResize);
				window.addEventListener("scroll", onClientResize);
				window.addEventListener("mousedown", onMouseDownOut);
				return () => {
					window.removeEventListener("resize", onClientResize);
					window.removeEventListener("scroll", onClientResize);
					window.removeEventListener("mousedown", onMouseDownOut);
				}
			}
		}
	}, []);

	const reRender = () => {
		setForceRender(Object.entries(choosing.current));
	}


	const onActivate = ( ) => {
		choosing.current = !choosing.current;
		reRender();
	}



	const onMouseDownOut = () => {
		if( choosing.current && !over.current ) {
			choosing.current = false;
			reRender();
		}
	}

	const onMouseOver = ( ) => {
		if( !over.current ) {
			over.current = true;
			setForceRender(Object.entries(choosing.current));
		}
	}

	const onMouseOut = ( ) => {
		if( over.current ) {
			over.current = false;
			setForceRender(Object.entries(choosing.current));
		}
	}

	if (address) {
		return (
			<div className={classes()} ref={compRef} onClick={onActivate} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
				<div className="addr">{formatAddress(address)}</div>
				{choosing.current && rect && <AccountDD rect={rect} />}
			</div>
		);
	}

	throw new Error("ConnectionManager::AccountEL was invoked to render but no address has been set");

}
